export const LANGUAGES = [
	{ label: "Deutsch", code: "de" },
	{ label: "English", code: "en" },
];
